import styled from 'styled-components';

import { Stack } from '../../stack/stack';

export const ButtonContainer = styled(Stack)`
  margin-top: 1em;
`;
